module.exports = __webpack_public_path__ + "img/thumbnail-sub.0df0f518.png";